export default [
  {
    path: '',
    name: 'request-quotes',
    component: () => import('pages/request-quotes/index.vue'),
    meta: {
      disableNext: ({ order }) => !order.jobsite || !order.reference_name || !order.scope_of_work,
      hideBackButton: true,
      next: { name: 'request-quotes-filter-suppliers' },
      step: 1,
    },
  },
  {
    path: 'filter-suppliers',
    name: 'request-quotes-filter-suppliers',
    component: () => import('pages/request-quotes/filter-suppliers.vue'),
    meta: {
      next: { name: 'request-quotes-invite-suppliers' },
      step: 2,
    }
  },
  {
    path: 'invite-suppliers',
    name: 'request-quotes-invite-suppliers',
    component: () => import('pages/request-quotes/invite-suppliers.vue'),
    meta: {
      disableNext: ({ contacts, suppliers }) => !contacts.length && !suppliers.length,
      next: { name: 'request-quotes-review-suppliers' },
      step: 2,
    },
  },
  {
    path: 'review-suppliers',
    name: 'request-quotes-review-suppliers',
    component: () => import('pages/request-quotes/review-suppliers.vue'),
    meta: {
      disableNext: ({ contacts, suppliers }) => !contacts.length && !suppliers.length,
      next: { name: 'request-quotes-delivery' },
      step: 2,
    },
  },
  {
    path: 'delivery',
    name: 'request-quotes-delivery',
    component: () => import('pages/request-quotes/delivery.vue'),
    meta: {
      next: { name: 'request-quotes-confirmation' },
      step: 3,
    },
  },
  {
    path: 'confirmation',
    name: 'request-quotes-confirmation',
    component: () => import('pages/request-quotes/confirmation.vue'),
    meta: {
      step: 4,
      submit: true,
    },
  },
]
